module.exports = __webpack_public_path__ + "img/arrow-down.85fe73db.svg";